module.exports = __webpack_public_path__ + "static/Q2Answer1_Maldives_wishmas-24e5647d0268cfab13cfb0fd163507c9.jpg";